
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import conf from "./../../config/base.js";
import { routerNames, invoiceTitleType } from "@/common/js/const.js";
import { setToken, getToken } from "@/common/js/common.js";
import regexpValid from "@/common/js/regexp.js";
import Box from 'vux/src/components/box/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Search from 'vux/src/components/search/index.vue'


export default {

components: {
Box,
Alert,
Group,

Cell,




XHeader,
XButton,
XInput,
XTextarea,
Search
},
data() {
return {
userPhoto: "",
userNickName: "我",
};
},
created() {},
activated() {
var $self = this;
$self.pageLoad();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {
var $self = this;

},
methods: {

pageLoad() {
var $self = this;
$self.$webapi.getUserInfo().then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var resData = res.data.result;
if (resData.wxUser) {
$self.userPhoto = resData.wxUser.headimgurl || "";
$self.userNickName = resData.wxUser.nickname || "我";
} else {
$self.userPhoto = "";
$self.userNickName = "我";
}
}
});
},

pageGoBack() {
var $self = this;
try {
if (____isAndroid) {
window.androidApi.backCalls();
} else {

window.iosApi.backCalls();
}
} catch (error) {


$self.$router.replace({
path: "/personal/index"
});
}
},
}
};
